export default {
  sysDict: '/static/sysDict/sysDictValue.json', // 系统数据字典
  afterLoanList: '/api/zma/loan/list', // 贷后跟踪获取列表数据接口
  loanDetail: '/api/zma/loan/loanDetail', // 贷款发放详情接口
  afterLoanDetail: '/api/zma/loan/info', // 贷后跟踪详情接口
  status: {
    '1_repulse': '/api/zma/loan/supplyShipBack', // 补充船期
    '1_pass': '/api/zma/loan/supplyShipPass', // 补充船期
    '102_repulse': '/api/zma/loan/loanAuditRepulse', // 船期放款审核 打回
    '1003_repulse': '/api/zma/loan/loanAuditRepulse',
    // '102_submit':'/api/zma/loan/loanAuditSubmit', // 船期放款审核 提交
    '102_submit': '/api/zma/loan/first/addCoftInfoFirst', // 船期放款审核 提交 福费廷协议内容
    '1003_submit': '/api/zma/loan/first/addCoftInfoFirst',
    '103_repulse': '/api/zma/loan/first/lendBack', // 放款一审 打回
    '1004_repulse': '/api/zma/loan/first/lendBack',
    '103_pass': '/api/zma/loan/first/lendThrough', // 放款一审 通过
    '1004_pass': '/api/zma/loan/first/lendThrough',
    '104_repulse': '/api/zma/loan/second/lendBack', // 放款二审 打回
    '1005_repulse': '/api/zma/loan/second/lendBack',
    '104_pass': '/api/zma/loan/second/lendThrough', // 放款二审 通过
    '1005_pass': '/api/zma/loan/second/lendThrough',
    '104_refuse': '/api/zma/loan/second/lendRefuse', // 放款二审 拒绝放款
    '1005_refuse': '/api/zma/loan/second/lendRefuse',
    // '108_submit':'/api/zma/loan/lendInfoThrough', // 放款资料审核 提交
    '108_submit': '/api/zma/loan/second/addCoftInfoSecond', // 放款资料审核 提交
    '1006_submit': '/api/zma/loan/second/addCoftInfoSecond',
    // '109_repulse':'/api/zma/loan/first/lendInfoBack', // 放款资料一审 打回
    // '109_pass':'/api/zma/loan/first/lendInfoThrough', // 放款资料一审 通过
    // '110_repulse':'/api/zma/loan/second/lendInfoBack', // 放款资料二审 打回
    // '110_pass':'/api/zma/loan/second/lendInfoThrough', // 放款资料二审 通过
    // '113_repulse':'/api/zma/loan/floatFlowBack', // 水单审核（船期流水审核） 打回
    // '113_submit':'/api/zma/loan/floatFlowThrough', // 水单审核（船期流水审核） 提交

    '140_repulse': '/api/zma/loan/audit/back', // 还款审核 打回
    '1011_repulse': '/api/zma/loan/audit/back',
    '140_submit': '/api/zma/loan/audit/pass', // 还款审核 提交
    '1011_submit': '/api/zma/loan/audit/pass',
    '150_repulse': '/api/zma/loan/firstLoanToBack', // 还款一审 打回
    '1012_repulse': '/api/zma/loan/firstLoanToBack',
    '150_pass': '/api/zma/loan/firstLoanToPass', // 还款一审 通过
    '1012_pass': '/api/zma/loan/firstLoanToPass',
    '160_repulse': '/api/zma/loan/secondLoanToBack', // 还款二审 打回
    '1013_repulse': '/api/zma/loan/secondLoanToBack',
    '160_pass': '/api/zma/loan/secondLoanPass', // 还款二审 通过
    '1013_pass': '/api/zma/loan/secondLoanPass'
  },
  checkBtnLimit: '/api/zma/loanMenu/checkMenu' // 判断订单是否展示审核按钮(包括 打回、通过等按钮)
}
// 102:放款审核中 103:放款一审中 104:放款二审中 105:放款资料审核中 106:放款资料一审中 107:放款资料二审中 108:放款通过
// 109:水单待确认 110:水单审核中 111:放款拒绝 112:放款打回 113:放款打回待确认
// 140还款审核中150还款一审中160还款二审中170还款完毕
